<template>
  <button :class="classes" @click="onClick" @keydown.esc="$emit('esc-pressed')" @keydown.enter.prevent="onClick" @keydown.space.prevent="onClick">
    <icon :name="mainIcon" class="trbo-a-info-icon__info" />
    <icon name="close" alt="close" class="trbo-a-info-icon__close" :aria-hidden="!isOpened" />
  </button>
</template>

<script>
// @flow

import Icon from '../../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    mainIcon: {
      type: String,
      default: 'info'
    },
    isOpened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-info-icon': true,
        'trbo-a-info-icon--is-opened': this.isOpened
      }
    }
  },
  methods: {
    onClick (event) {
      event.stopPropagation()
      this.$emit('click')
    }
  }
}
</script>

<style scoped src="./info-icon.scss" />
